<!-- /src/views/Courses.vue -->
<template>
  <LayoutFullWidth class="landing--page">
    <template v-slot:header>
      <h1 id="page-header" class="page-header">Courses</h1>
          <div class="card-grid-header__actions button__group">
            <button
              class="filter--trigger button button--gray button--sm"
              @click="toggleFilters()"
            ><span v-if="activeQueries.length > 0">Modify Filtered Results</span>
            <span v-else>Filter Results</span></button>
            <Sort />
          </div>
    </template>
    <template v-slot:content>
      <div class="main-content">
        <div class="filter-panel"
          v-show="showFilters"
        >
          <Filters :postType="sessionType" />
          <button
            class="button button--gray button--medium button--accent"
            @click="toggleFilters()"
          >Close Filter Panel</button>
        </div>
        <header class="card-grid-header">
          <ActiveQueries />
        </header>
        <CardGrid v-if="pageCards.length > 0" :cards="pageCards" />
        <NoResults v-else-if="noCards">
          <h2>Whoops! Looks like we do not have courses related to your query.</h2>
          If you think this topic would be helpful to others, please consider using the "Need Help?" feature in the upper right.
        </NoResults>
        <Loader v-else="!noCards" color="gray" />
        <div v-else>
          Sorry, no {{ type.titlePlural }} are available with these filter
          settings!
        </div>

        <Pagination v-if="totalPages > 1" :page="page" :total="totalPages" />
      </div>
    </template>
  </LayoutFullWidth>
</template>

<script>
import LayoutFullWidth from '@/components/layouts/FullWidth'
import CardGrid from '@/components/common/Card/CardGrid'
import Sort from '@/components/common/Sort'
import Filters from '@/components/common/Sidebar/Filters'
import ActiveQueries from '@/components/common/Search/ActiveQueries'
import Pagination from '@/components/common/Pagination'
import searchMixin from '@/mixins/searchMixin'
import _omit from 'lodash/omit'
import _values from 'lodash/values'
import _each from 'lodash/each'
import _isNaN from 'lodash/isNaN'
import _pick from 'lodash/pick'
import _keys from 'lodash/keys'
import Loader from '@/components/common/Loaders/Loader'
import NoResults from '@/components/common/Loaders/NoResults'

export default {
  name: 'courses',
  data() {
    return {
      cardCount: 0,
      noCards: false,
      sessionType: 'courses',
      postType: 'course',
      showFilters: false,
    }
  },

  computed: {
    page() {
      const { page } = Object.create(this.$route.query)
      return typeof page != 'undefined' ? page : 1
    },
 
    cards() {
      let cards = Object.create(
        this.$store.getters['posts/getAll'](this.sessionType),
      )
      // cards = this.filterCards(cards)

      // if (cards.length == 0) {
      //   this.checkCards()
      // }

      return cards
    },

    pageCards() {
      return this.cards
    },

    itemsPerPage() {
      return this.$store.getters['posts/getItemsPerPage'](this.sessionType)
    },

    totalPages() {
      return this.$store.getters['posts/getTotalPages'](this.sessionType)
    },
  },

  watch: {
    cards(newCards) {
      this.noCards = newCards.length == 0
      return newCards
    }
  },

  methods: {
    checkCards() {
      setTimeout(() => {
        if (this.cards.length == 0) this.noCards = true
      }, 5000)
    },

    removeFilterItem(queryItem) {
      let { query, name } = this.$route
      query = _omit(query, _keys(queryItem))
      this.$router.push({
        name,
        query,
      })
    },

    getSessionType() {
      return this.$route.params.sessionType
    },

    toggleFilters() {
      this.showFilters = !this.showFilters
    },

    initialCaps(string) {
      return string.split(' ').map(word => {
        return word[0].toUpperCase() + word.substr(1)
      }).join(' ')
    },

    containsId(arr1, arr2) {
      var ret = []
      arr1.sort()
      arr2.sort()
      for (var i = 0; i < arr1.length; i += 1) {
        if (arr2.indexOf(arr1[i]) > -1) {
          ret.push(arr1[i])
        }
      }
      return ret
    },
  },

  mounted() {
    this.checkCards()
  },

  beforeMount() {
    this.$store.dispatch('updatePageTitle', 'Courses')
  },

  mixins: [searchMixin],

  components: {
    LayoutFullWidth,
    CardGrid,
    Pagination,
    Filters,
    Sort,
    ActiveQueries,
    Loader,
    NoResults,
  },
}
</script>

<style scoped>
.card-grid-header {
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto;
  margin-bottom: 1rem;

  h2 {
    margin-bottom: 0;
  }

  &__actions {
    font-size: 0.7em;
    justify-self: start;
    grid-template-columns: 1fr;
    display: grid;
    @media(--tablet) {
      display: flex;
      /* grid */
    }
  }
}

.filter-panel {
  display: grid;
  margin-bottom: 1rem;
  padding: 1rem;
  gap: 1rem;
  background-color: rgba(var(--gray-RGB), .3);
  border-radius: 4px;

  &> button {
    justify-self: end;
    font-size: .6rem;
    padding: .35rem .5rem;
  }
}

.form__control {
  margin: 0;
}
</style>
